export default __webpack_public_path__ + "static/media/ysd-008-setu3.e1ca3b6b.jpg";